import { render, staticRenderFns } from "./PurchaseOfferingFlow.vue?vue&type=template&id=47d5dbf8&scoped=true"
import script from "./PurchaseOfferingFlow.vue?vue&type=script&lang=js"
export * from "./PurchaseOfferingFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5dbf8",
  null
  
)

export default component.exports